// angular
// 	.module("HeroPRO")
// 	.controller("ProjectAdvanceController", projectAdvanceController);

import _ from 'lodash';

import './projectAdvance.scss';
/* @ngInject */
export default function projectAdvanceController(ProjectAdvanceFactory) {
    const vm = this;
    vm.loadingData = true;
    vm.advanceData = {};

    init();


    /*= =======================================
	 =            Public Functions            =
	 ======================================== */


    /* -----  End of Public Functions  ------*/

    /*= =======================================
	 =            Private Functions            =
	 ======================================== */

    function init() {
        ProjectAdvanceFactory.getProjectAdvanceDetails().then((response) => {
		    vm.advanceData = response.data.Data;
		    vm.loadingData = false;
        });
    }


    /* -----  End of Private Functions  ------*/
}



// WEBPACK FOOTER //
// ./src/app/pipeline/pipelineTable/projectAdvanceTemplates/projectAdvanceController.js